import { AddIcon, CloseIcon } from '@assets/icons';
import { IconButton } from '@components/button';
import { Tab, TabPanel, Tabs } from '@components/tabs';
import { Backdrop, Box, Stack, useTheme } from '@mui/material';
import { useState } from 'react';
import { useToggle } from 'react-use';
import { ChannelNodeTreeView } from './ChannelNodeTreeView';
import { ChannelVolumeTreeView } from './ChannelVolumeTreeView';

type AddNodeButtonProps = {
  workspaceId: string;
};

export const AddNodeButton = (props: AddNodeButtonProps) => {
  const { palette } = useTheme();
  const [value, setValue] = useState<string>('');
  const [open, toggleOpen] = useToggle(false);

  const drawerWidth = 370;

  return (
    <>
      <Backdrop
        open={open}
        onClick={toggleOpen}
        sx={{
          zIndex: 1199,
          position: 'absolute',
        }}
      />

      {/* Drawer Panel */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          width: open ? drawerWidth : 0,
          backgroundColor: palette.graph.drawer.background,
          borderTop: `1px solid ${palette.background.default}`,
          overflow: 'hidden',
          transition: 'all 0.3s ease-in-out',
          zIndex: 1200,
        }}
      >
        <Stack
          sx={{
            height: '100%',
            paddingX: 4,
            paddingTop: 6,
            opacity: open ? 1 : 0,
            transition: 'opacity 0.3s ease-in-out',
          }}
        >
          <Tabs
            value={value}
            variant="fullWidth"
            onChange={(_, tabValue: string) => setValue(tabValue)}
          >
            <Tab value="" label="Channel" />
            <Tab value="volumes" label="Volumes" />
          </Tabs>

          <TabPanel value={value} index="" width="100%" sx={{ flex: 1, overflow: 'auto' }}>
            <ChannelNodeTreeView />
          </TabPanel>
          <TabPanel value={value} index="volumes" width="100%" sx={{ flex: 1, overflow: 'auto' }}>
            <ChannelVolumeTreeView {...props} />
          </TabPanel>
        </Stack>
      </Box>

      {/* Trigger Button - Always Visible */}
      <Box
        position="absolute"
        top={16}
        left={open ? drawerWidth : 0}
        justifyContent="center"
        bgcolor={palette.graph.drawer.background}
        sx={{
          padding: 2,
          borderRadius: '0 4px 4px 0',
          border: `1px solid ${palette.grey[500]}`,
          borderLeft: 'none',
          transition: 'left 0.3s ease-in-out',
          zIndex: 1201,
        }}
      >
        <IconButton
          size={24}
          data-testid="addNodeButton"
          data-cy="Add-Node-Button"
          onClick={toggleOpen}
          Icon={open ? CloseIcon : AddIcon}
        />
      </Box>
    </>
  );
};
